import React, { useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';
import '../css/Form.css'
import _ from "lodash";

const ProCustomAutoComplete = ({id, labelText, value, suggestions, completeMethod, field, onChange,
     minLength = 1, selectedItemTemplate, style={width: '100%', minHeight:'40px'}, headerText, disabled=false, required})=>{

        const placeholderText = required?<label htmlFor="inputtext">{labelText}</label>
        : <label htmlFor="inputtext">{labelText}<span style={{fontSize:11}}>  (optional)</span></label>
        useEffect(()=>{ 
            if(!disabled){         
                var ele = document.getElementById(id)
                ele.childNodes[0].childNodes.forEach((element) => {
                    if(element.childNodes.length === 2)
                    {
                    var index =  _.findIndex(value, (e)=> e.fullName === element.firstChild.textContent)
                        if(index >= 0){
                            element.className = value[index].isInherited? `${element.className} inherited-staff` : element.className;
                            value[index].isInherited && element.removeChild(element.lastChild)
                        }
                    }  
                });
        }

        }, [id, value, disabled])
   return (<div className="p-field p-col-12">
            {
                headerText && 
                <div className="p-d-flex p-jc-start">
                <h6 className="form-header">{headerText}</h6>
            </div>
            }
            <span className="p-float-label p-fluid">
                <AutoComplete id={id}  multiple
                                field={field}
                                value={value}  
                                suggestions = {suggestions||[]}
                                completeMethod = {completeMethod} 
                                selectedItemTemplate = {selectedItemTemplate}                               
                                minLength = {minLength}                         
                                onChange={onChange}                               
                                style={{...style}}
                                disabled={disabled}
                                                    
                            />                    
                {placeholderText}
            </span>            
        </div>)
}

export default ProCustomAutoComplete;